/**
 * 加载进度指示器组件
 * 验证需求：12.3
 * 属性17：加载状态反馈
 */
import { Spin, Progress } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

interface LoadingIndicatorProps {
  loading?: boolean;
  tip?: string;
  size?: 'small' | 'default' | 'large';
  fullscreen?: boolean;
  progress?: number; // 0-100，如果提供则显示进度条
}

export default function LoadingIndicator({
  loading = true,
  tip = '加载中...',
  size = 'default',
  fullscreen = false,
  progress,
}: LoadingIndicatorProps) {
  if (!loading) {
    return null;
  }

  const antIcon = <LoadingOutlined style={{ fontSize: size === 'large' ? 48 : 24 }} spin />;

  const content = (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
      }}
    >
      <Spin indicator={antIcon} size={size} tip={tip} />
      {progress !== undefined && (
        <Progress
          percent={progress}
          style={{ width: 200 }}
          status={progress === 100 ? 'success' : 'active'}
        />
      )}
    </div>
  );

  if (fullscreen) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(255, 255, 255, 0.9)',
          zIndex: 9999,
        }}
      >
        {content}
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '50px 0',
      }}
    >
      {content}
    </div>
  );
}
